module.exports = __webpack_public_path__ + "assets/images/slope-single/desktop.svg?v=2f9fa3c0";